<template>
  <BaseModal
    name="sendNotificationModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="
      () => {
        foundFrom = [];
      }
    "
    @before-open="loadData"
    :adaptive="true"
    height="auto"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <BaseLoader v-if="localLoading" class="tw-rounded-[25px]"></BaseLoader>
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('sendNotificationModal')"
      ></button>
      <div>
        <div class="tw-app-modal__title">{{ dataLang["reg_company_102"] }}</div>

        <div ref="text">
          <BaseTextarea
            inputClass="tw-app-input-type-3"
            placeholder=""
            signClass=""
            input-name="text"
            @onInput="updateValue"
            :minHeight="'125'"
            name-sign=""
            value=""
          >
          </BaseTextarea>
        </div>

        <div class="tw-app-modal__footer">
          <button
            @click="$modal.hide('sendNotificationModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            {{ dataLang["clients_register_text_96"] }}
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            {{ dataLang["orders_sms_presets_text7"] }}
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import { VeTable } from "vue-easytable";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {
    VeTable,
  },

  props: {},
  data() {
    return {
      typeOperation: "",
      localLoading: false,
      dataForEmit: {},
      pincode: "",
      currentId: null,
    };
  },
  methods: {
    loadData({ params }) {
      this.typeOperation = params?.type;
      this.pincode = params?.pincode;

      // /clients/table/active?count=0&limit=100&total=0&page=0
    },
    beforeClose(event) {
      this.dataForEmit = {};
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove("input-error");
      }
      //   this.$refs[data.name].classList.remove('input-error')
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    sendData() {
      if (Object.keys(this.dataForEmit).length) {
        this.localLoading = true;
        GeneralService.get(`/whoami`).then((data) => {
          GeneralService.editOrCreate(
            this.typeOperation == "all"
              ? `/notification/all?pincode=${this.pincode}`
              : `/notification?pincode=${this.pincode}`,
            {
              ...this.dataForEmit,
              ...(this.typeOperation !== "all" && {
                companyId: data.data.data.company_lc,
              }),
            }
          )
            .then((gege) => {
              console.log(gege);
              this.$toast.success(gege.data.message);
            })
            .catch((e) => {
              console.error(e);
              this.$toast.error(e.response.data.message, { duration: 5000 });
              setTimeout(() => {
                Object.keys(e.response.data.errors).forEach((elem, index) => {
                  if (this.$refs[elem]) {
                    this.$refs[elem].classList.add("input-error");
                  }
                });
              }, 10);
            })
            .finally(() => {
              this.$modal.hide("sendNotificationModal");
              this.localLoading = false;
            });
        });
      }
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
